import { Link } from 'react-router-dom';
import { MapPin, Phone, MessageCircle, Instagram, Facebook } from 'lucide-react';
import { useSiteConfig } from '../utils/siteConfig';

export default function Footer() {
  const { store } = useSiteConfig();
  const telHref = `tel:+55${store.phone.replace(/\D/g, '')}`;

  return (
    <footer className="mt-20 bg-navy-dark text-white" data-testid="site-footer">
      <div className="mx-auto grid max-w-7xl gap-10 px-4 py-14 md:grid-cols-3">
        <div>
          <p className="font-serif text-2xl">H<span className="font-normal">UDDERSFIELD</span></p>
          <p className="text-[10px] font-semibold tracking-[0.35em] text-white/80">TECIDOS</p>
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-white/70">
            Tradição em tecidos no centro de Curitiba. Atendimento especializado para moda,
            alfaiataria, decoração e artesanato.
          </p>
          {(store.instagram || store.facebook) && (
            <div className="mt-4 flex gap-2" data-testid="footer-social-links">
              {store.instagram && (
                <a href={store.instagram} target="_blank" rel="noreferrer" aria-label="Instagram" data-testid="footer-instagram-link" className="flex h-10 w-10 items-center justify-center rounded-full border border-white/20 text-white/80 hover:bg-white/10 hover:text-white">
                  <Instagram className="h-4 w-4" />
                </a>
              )}
              {store.facebook && (
                <a href={store.facebook} target="_blank" rel="noreferrer" aria-label="Facebook" data-testid="footer-facebook-link" className="flex h-10 w-10 items-center justify-center rounded-full border border-white/20 text-white/80 hover:bg-white/10 hover:text-white">
                  <Facebook className="h-4 w-4" />
                </a>
              )}
            </div>
          )}
        </div>
        <div className="text-sm text-white/80">
          <p className="mb-4 text-xs font-semibold uppercase tracking-[0.2em] text-white/50">Loja física</p>
          <p className="flex items-start gap-2">
            <MapPin className="mt-0.5 h-4 w-4 shrink-0" /> <span data-testid="footer-address">{store.address}</span>
          </p>
          <p className="ml-6" data-testid="footer-city">{store.cityUf}</p>
          <a href={telHref} className="mt-3 flex items-center gap-2 hover:text-white" data-testid="footer-phone">
            <Phone className="h-4 w-4" /> {store.phone}
          </a>
          <a
            href={`https://wa.me/${store.whatsappDigits}`}
            target="_blank"
            rel="noreferrer"
            className="mt-2 flex items-center gap-2 hover:text-white"
            data-testid="footer-whatsapp"
          >
            <MessageCircle className="h-4 w-4" /> WhatsApp {store.whatsapp}
          </a>
        </div>
        <nav className="text-sm" aria-label="Links do rodapé">
          <p className="mb-4 text-xs font-semibold uppercase tracking-[0.2em] text-white/50">Links</p>
          <ul className="space-y-2.5 text-white/80">
            <li><Link to="/nossa-loja" className="hover:text-white" data-testid="footer-link-store">Nossa Loja</Link></li>
            <li><a href={`https://wa.me/${store.whatsappDigits}`} target="_blank" rel="noreferrer" className="hover:text-white" data-testid="footer-link-contact">Contato</a></li>
            <li><Link to="/categoria/todos" className="hover:text-white" data-testid="footer-link-all-fabrics">Todos os Tecidos</Link></li>
            <li><Link to="/#como-funciona" className="hover:text-white" data-testid="footer-link-how-it-works">Como funciona</Link></li>
            <li><Link to="/privacidade" className="hover:text-white" data-testid="footer-link-privacy">Política de Privacidade</Link></li>
          </ul>
        </nav>
      </div>
      <div className="border-t border-white/10 py-5 text-center text-xs text-white/50">
        © {new Date().getFullYear()} Huddersfield Tecidos · Loja física em Curitiba/PR
        <span className="mx-2 text-white/25">·</span>
        <Link
          to="/admin"
          data-testid="footer-link-admin"
          className="text-white/35 transition-colors hover:text-white/70"
          aria-label="Acesso da equipe ao painel administrativo"
        >
          Acesso da equipe
        </Link>
      </div>
    </footer>
  );
}
